var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29036 22.3333H20.332C23.3176 22.3333 24.8104 22.3333 25.7379 21.4058C26.6654 20.4783 26.6654 18.9856 26.6654 16V8.08333C26.6654 5.09777 26.6654 3.60499 25.7379 2.6775C24.8104 1.75 23.3176 1.75 20.332 1.75H7.66536C4.6798 1.75 3.18702 1.75 2.25953 2.6775C1.33203 3.60499 1.33203 5.09777 1.33203 8.08333V26.2917C1.33203 24.1055 3.10424 22.3333 5.29036 22.3333ZM9.2487 7.66667C8.14413 7.66667 7.2487 8.5621 7.2487 9.66667C7.2487 10.7712 8.14413 11.6667 9.2487 11.6667L18.7487 11.6667C19.8533 11.6667 20.7487 10.7712 20.7487 9.66667C20.7487 8.5621 19.8533 7.66667 18.7487 7.66667L9.2487 7.66667Z",
    fill: "#E1E1E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 26.2917V8.08333C1.33203 5.09777 1.33203 3.60499 2.25953 2.6775C3.18702 1.75 4.6798 1.75 7.66536 1.75H20.332C23.3176 1.75 24.8104 1.75 25.7379 2.6775C26.6654 3.60499 26.6654 5.09777 26.6654 8.08333V16C26.6654 18.9856 26.6654 20.4783 25.7379 21.4058C24.8104 22.3333 23.3176 22.3333 20.332 22.3333H5.29036C3.10424 22.3333 1.33203 24.1055 1.33203 26.2917ZM1.33203 26.2917C1.33203 28.4778 3.10424 30.25 5.29036 30.25H12.4154M26.6654 30.25H10.832M7.2487 9.66667C7.2487 8.5621 8.14413 7.66667 9.2487 7.66667L18.7487 7.66667C19.8533 7.66667 20.7487 8.5621 20.7487 9.66667C20.7487 10.7712 19.8533 11.6667 18.7487 11.6667L9.2487 11.6667C8.14413 11.6667 7.2487 10.7712 7.2487 9.66667Z",
    stroke: "#E1E1E6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/Course.590dbed73fd559ac3c074762f60c147d.svg";
export { ForwardRef as ReactComponent };